import * as types from './mutation_types'

export default {
  [types.SET_I18N_CATALOG](state, payload) {
    state.catalog = payload.catalog||{};
    state.plural = payload.plural||null;
    state.formats = payload.formats||{};
  }
}
